import { LanguageIsoCodeEnumSchema } from "@iot-platform/core";
import { UserRoleEnumSchema } from "@iot-platform/user";
import * as z from "zod";

const minPasswordLength = 6;
const maxPasswordLength = 128;

const passwordSchema = z
    .string()
    .trim()
    .min(minPasswordLength)
    .max(maxPasswordLength);

export const LoginSchema = z
    .object({
        email: z.email(),
        password: passwordSchema,
        language: LanguageIsoCodeEnumSchema.optional(),
    })
    .readonly()
    .brand<"Login">();

export type LoginInputProps = z.input<typeof LoginSchema>;
export type Login = z.output<typeof LoginSchema>;

export const LoginUserSchema = z
    .object({
        id: z.int().positive(),
        rol: UserRoleEnumSchema.nullable(),
        name: z.string().trim().nullable(),
        email: z.email(),
        language: LanguageIsoCodeEnumSchema.optional(),
        token: z.string().trim(),
        timeZone: z.string().trim(),
    })
    .readonly()
    .brand<"LoginUser">();

export type LoginUserInputProps = z.input<typeof LoginUserSchema>;
export type LoginUser = z.output<typeof LoginUserSchema>;

export const PasswordRecoverySchema = z
    .object({
        email: z.email(),
    })
    .readonly()
    .brand<"PasswordRecovery">();

export type PasswordRecoveryInputProps = z.input<typeof PasswordRecoverySchema>;
export type PasswordRecovery = z.output<typeof PasswordRecoverySchema>;
